import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Menu, Image, Dropdown as SemanticDropDown, Header, Icon } from 'semantic-ui-react';
import { endpoint } from '../../api/http';
import { Images } from '../../assets/assets';
import LanguageContext from '../../language';
import moment from 'moment';
import { dateFormat } from '../../components/shared/constants';

const MenuBar = ({ user, hasSelectedReservation, onReturnToArrivals
    //TODO: components array as prop
}) => {
    const language = useContext(LanguageContext)
    const text = key => {
        return language ? language.texts[key] : key
    }

    const OnLogoutClicked = () => {
        if (window.optima && window.optima.utils) {
            window.optima.utils.PostMessage({ eventType: 'Logout' });
        }
    }

    return (
        <div className="apartment-menu">
            <Menu borderless activeIndex="-1" size="small" >

                <Menu.Item key='logo'>
                    <Image src={Images.logo} href={`${endpoint}PMS/ReceptionAnywhere`} size="mini" ></Image>
                </Menu.Item>

                {hasSelectedReservation &&
                    <Menu.Item onClick={onReturnToArrivals}>
                        <Header as='h3'>
                            <Icon name="arrow left" />
                        </Header>
                    </Menu.Item>
                }

                <Menu.Item>
                    <Header as='h3'>{text("ReceptionAnywhere")}</Header>
                </Menu.Item>
                <Menu.Item>
                    <Header as='h3'>{moment(window.user?.CurrentHotel?.HotelParameter?.CurrentBusinessDate).format(dateFormat)}</Header>
                </Menu.Item>


                <Menu.Menu position="right">

                    <SemanticDropDown simple item trigger={
                        <div>
                            <Image src={Images.login_avatar} avatar size="mini" />
                            {user && <span style={{ verticalAlign: "middle" }}>{user.UserName}</span>}
                        </div>

                    }>
                        <SemanticDropDown.Menu>
                            <Menu.Item link href={`${endpoint}Organization/User/Edit?isUserProfile=true&userID=${user.Id}&apartmentOwnerPortal=true&receptionAnywhere=true`}>{text("Profile")}</Menu.Item>
                            <Menu.Item link href={`${endpoint}Organization/Account/LogOut`} onClick={OnLogoutClicked}>{text("LogOut")}</Menu.Item>
                        </SemanticDropDown.Menu>
                    </SemanticDropDown>

                </Menu.Menu>
            </Menu>
        </div>
    )
}
MenuBar.propTypes = {
    user: PropTypes.object,
    onReturnToArrivals: PropTypes.func,
    hasSelectedReservation: PropTypes.bool,
}
export default MenuBar